import React from 'react';
import { Link } from 'react-router-dom';

import Button from '@mui/material/Button';
import { Routes } from 'constants/pages';
import { useRegion } from 'common/hooks/region';
import { Permission, useHasPermission } from 'utils/permissions';
import { PortCollectionFeature } from 'types/Port';

interface Props {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  disabled: boolean;
}

export const StopTheClockButton: React.FC<Props> = (props) => {
  const { onClick, disabled } = props;

  const region = useRegion();
  const hasPermission = useHasPermission([Permission.EmptyReturnLocationDownload]);
  const comingSoon = !region.features?.includes(PortCollectionFeature.StopTheClock);
  const disableStopTheClock = comingSoon || !hasPermission || disabled;

  return (
    <div className="text-center	">
      <Button
        variant="contained"
        color="secondary"
        onClick={onClick}
        disabled={disableStopTheClock}
        style={{ height: '65px', width: '256px' }}
      >
        <h3>Stop the Clock</h3>
      </Button>
      {comingSoon && (
        <div className="absolute text-center p-2" style={{ width: '256px' }}>
          <h5>Coming Soon</h5>
        </div>
      )}
      {!hasPermission && (
        <div className="absolute text-center p-2" style={{ width: '256px' }}>
          <h4>
            <Link className="text-blue-900 underline" to={Routes.Plans}>
              Upgrade
            </Link>{' '}
            for historical screenshots
          </h4>
        </div>
      )}
    </div>
  );
};
